import React from 'react';
import { PillRow } from './controls';
import { datesOf, eventsOnDate, isAnswered } from '../state/derive';
import { fmtDatePill } from '../state/format';
import { useWeddingDay } from '../state/useWeddingDay';

const e = React.createElement;

// The booked days, with how many events sit on each. Both sides share a day,
// so the count is the day's own.
const DatePills = () => {
  const { events, activeDate, setActiveDate } = useWeddingDay();
  const dates = datesOf(events);

  const pills = dates.map((d) => {
    const day = eventsOnDate(events, d);
    // A day is filled once every card on it is closed, and a card only
    // closes with everything it needs. Marked so the couple can see which
    // days are left without opening each one.
    const done = day.length > 0 && day.every(isAnswered);
    return e(
      'button',
      {
        key: d,
        type: 'button',
        className: `wd-pill${d === activeDate ? ' is-on' : ''}${done ? ' is-done' : ''}`,
        'aria-label': `${fmtDatePill(d)}, ${day.length} events${done ? ', all filled' : ''}`,
        onClick: () => setActiveDate(d),
      },
      [
        e('span', { className: 'wd-d', key: 'd' }, fmtDatePill(d)),
        e(
          'span',
          { className: `wd-n${done ? ' is-done' : ''}`, key: 'n' },
          done ? `\u2713 ${day.length}` : String(day.length)
        ),
      ]
    );
  });

  // Every date is in the row. As many as fit are on screen and the rest are
  // a swipe away, which is how a phone reads a row of days.
  return e(PillRow, { items: pills });
};

export default DatePills;
